import axios from 'axios';
import React, { useState } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import toast from 'react-hot-toast';

export default function AddTaskModal({ show, onHide, onSubmit }) {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    userId: '', 
    taskId: '',  
    task: '',
    priority: 'Low',
    deadline: '',
    tone: 'Neutral'
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const res = await axios.post(`${apiUrl}/add-manually-task`, formData, {
        withCredentials: true
      });

      if (res.status === 200 || res.status === 201) {
        toast.success('Task added successfully!');

        if (onSubmit) {
          onSubmit(res.data.task);
        }

        setFormData({
          userId: '',
          taskId: '',
          task: '',
          priority: 'Low',
          deadline: '',
          tone: 'Neutral'
        });

        onHide();
      } else {
        toast.error('Something went wrong while adding the task.');
      }
    } catch (error) {
      console.error('Error adding task:', error);
      toast.error(error?.response?.data?.message || 'Failed to add task.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add New Task</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="task">
            <Form.Label>Task Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="task"
              value={formData.task}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3" controlId="priority">
                <Form.Label>Priority</Form.Label>
                <Form.Select
                  name="priority"
                  value={formData.priority}
                  onChange={handleChange}
                  required
                >
                  <option value="Low">Low</option>
                  <option value="Medium">Medium</option>
                  <option value="High">High</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3" controlId="deadline">
                <Form.Label>Deadline</Form.Label>
                <Form.Control
                  type="datetime-local"
                  name="deadline"
                  value={formData.deadline}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-3" controlId="tone">
            <Form.Label>Tone</Form.Label>
            <Form.Select
              name="tone"
              value={formData.tone}
              onChange={handleChange}
              required
            >
              <option value="Neutral">Neutral</option>
              <option value="Praise">Praise</option>
              <option value="Recognition">Recognition</option>
              <option value="Frustration">Frustration</option>
              <option value="Conflict">Conflict</option>
            </Form.Select>
          </Form.Group>

          <Modal.Footer>
            <Button variant="secondary" onClick={onHide} disabled={isSubmitting}>
              Close
            </Button>
            <Button
              variant="primary"
              type="submit"
              disabled={isSubmitting}
              style={{ width: '100px' }}
            >
              {isSubmitting ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                </>
              ) : (
                'Add Task'
              )}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  );
}
